import NewInspection from "@/views/agro_exporter/quality_control/crop_field/NewInspection.vue";
import EditInspection from "@/views/agro_exporter/quality_control/crop_field/EditInspection.vue";
import ListProducers from "@/views/agro_exporter/quality_control/crop_field/ListProducers.vue";
import ListCropFields from "@/views/agro_exporter/quality_control/crop_field/ListCropFields.vue";
import ListTemplates from "@/views/agro_exporter/quality_control/crop_field/ListTemplates.vue";
import CropFieldInspectGraphs from "@/views/agro_exporter/quality_control/crop_field/CropFieldInspectGraphs.vue";
import ListQualityInspects from "@/views/agro_exporter/quality_control/crop_field/ListQualityInspects.vue";
import ShowQualityInspect from "@/views/agro_exporter/quality_control/crop_field/ShowQualityInspect.vue";


import { routerUtilities } from "@/components/views/mixins/module_routes.js";
const [META, routeName] = routerUtilities({
  entity: "ae",
  role: "quality_control",
  permission: "crop_field",
});

export default [
  {
    path: "/ae/:agro_exporter_id/quality_control/crop_field/list_producers",
    name: routeName(""),
    redirect: { name: routeName("list_producers") }
  },
  {
    path: "/ae/:agro_exporter_id/quality_control/crop_field/new_inspection/:producer_id/:crop_field_id/:exporter_process_quality_template_id/:quality_template_id",
    name: routeName("new_inspection"),
    component: NewInspection,
    props: true,
    meta: META
  },
  {
    path: "/ae/:agro_exporter_id/quality_control/crop_field/edit_inspection/:producer_id/:crop_field_id/:exporter_process_quality_template_id/:quality_template_id/:quality_inspect_id",
    name: routeName("edit_inspection"),
    component: EditInspection,
    props: true,
    meta: META
  },
  {
    path: "/ae/:agro_exporter_id/quality_control/crop_field/list_producers",
    name: routeName("list_producers"),
    component: ListProducers,
    props: true,
    meta: META
  },
  {
    path: "/ae/:agro_exporter_id/quality_control/crop_field/list_crop_fields/:producer_id",
    name: routeName("list_crop_fields"),
    component: ListCropFields,
    props: true,
    meta: META
  },
  {
    path: "/ae/:agro_exporter_id/quality_control/crop_field/list_templates/:producer_id/:crop_field_id",
    name: routeName("list_templates"),
    component: ListTemplates,
    props: true,
    meta: META
  },
  {
    path: "/ae/:agro_exporter_id/quality_control/crop_field/crop_field_inspect_graphs/:producer_id/exporter_process_quality_template/:exporter_process_quality_template_id",
    name: routeName("crop_field_inspect_graphs"),
    component: CropFieldInspectGraphs,
    props: true,
    meta: META
  },
  {
    path: "/ae/:agro_exporter_id/quality_control/crop_field/list_quality_inspects/:producer_id/:crop_field_id/:exporter_process_quality_template_id",
    name: routeName("list_quality_inspects"),
    component: ListQualityInspects,
    props: true,
    meta: META
  },
  {
    path: "/ae/:agro_exporter_id/quality_control/crop_field/show_quality_inspect/:producer_id/:crop_field_id/:exporter_process_quality_template_id/:quality_inspect_id",
    name: routeName("show_quality_inspect"),
    component: ShowQualityInspect,
    props: true,
    meta: META
  }
];
